import { AnimatePresence, motion } from 'framer-motion'
import type { ReactNode } from 'react'
import { SocialBar } from './SocialBar'
import logoBlue from '@/assets/brand/doneverse-logo-blue.png'
import cardsGroupMobile from '@/assets/brand/login-cards-group-mobile.png'
import cardsGroup from '@/assets/brand/login-cards-group.webp'
import styles from '@/pages/Index.module.css'

interface AuthSplitLayoutProps {
  heading: ReactNode
  subtitle: string
  children: ReactNode
  rightImageSrc?: string
  rightImageAlt?: string
  rightBackground?: 'default' | 'forgotPassword'
  animateHeadingSubtitle?: boolean
  subtitleMarginBottom?: number
  onGoogleClick?: () => void
}

export function AuthSplitLayout({
  heading,
  subtitle,
  children,
  rightImageSrc,
  rightImageAlt = '',
  rightBackground = 'default',
  animateHeadingSubtitle = false,
  subtitleMarginBottom,
  onGoogleClick,
}: AuthSplitLayoutProps) {
  const rightPanelClass =
    rightBackground === 'forgotPassword'
      ? `${styles.rightPanel} ${styles.rightPanelForgotPassword}`
      : styles.rightPanel
  const mobileShowcaseClass =
    rightBackground === 'forgotPassword'
      ? `${styles.mobileShowcase} ${styles.mobileShowcaseForgotPassword}`
      : styles.mobileShowcase

  const subtitleStyle =
    subtitleMarginBottom === undefined ? undefined : { marginBottom: `${subtitleMarginBottom}px` }

  return (
    <div className={styles.page}>
      <div className={styles.leftPanel}>
        <img src={logoBlue} alt="Doneverse" className={styles.logo} />

        <div className={styles.leftContent}>
          {animateHeadingSubtitle ? (
            <AnimatePresence mode="wait" initial={false}>
              <motion.div
                key={`${heading}-${subtitle}`}
                initial={{ opacity: 0, y: 8 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -8 }}
                transition={{ duration: 0.24, ease: 'easeOut' }}
              >
                <h1 className={styles.heading}>{heading}</h1>
                <p className={styles.subtitle} style={subtitleStyle}>
                  {subtitle}
                </p>
              </motion.div>
            </AnimatePresence>
          ) : (
            <>
              <h1 className={styles.heading}>{heading}</h1>
              <p className={styles.subtitle} style={subtitleStyle}>
                {subtitle}
              </p>
            </>
          )}
          {children}
          <div className={styles.authSocialDesktop}>
            <SocialBar onGoogleClick={onGoogleClick} />
          </div>
        </div>
      </div>

      <div className={rightPanelClass}>
        <img src={rightImageSrc || cardsGroup} alt={rightImageAlt} className={styles.cardsImage} />
      </div>

      <div className={mobileShowcaseClass}>
        <img
          src={rightImageSrc || cardsGroupMobile}
          alt={rightImageAlt}
          className={styles.mobileShowcaseImage}
        />
      </div>

      <div className={styles.authSocialMobile}>
        <SocialBar onGoogleClick={onGoogleClick} />
      </div>
    </div>
  )
}
